import { useMutation } from "@apollo/client/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import { constantsData, identifiersData, namesData, statusTypesData } from "@/data";
import { getDistributionsListQuery, takeDownAppleDistributionMutation } from "@/graph";
import { openAlert } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useTakeDownAppleDistribution = (releaseId, limit, page) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const [takeDownAppleDistributionAction, { loading }] = useMutation(takeDownAppleDistributionMutation, {
        awaitRefetchQueries: true,
        refetchQueries: [
            {
                query: getDistributionsListQuery,
                variables: {
                    limit,
                    page,
                    ...(releaseId && { releaseId }),
                },
            },
        ],
    });

    const { startedDistributionTakeDown: startedDistributionTakeDownToastName } = namesData.toasts;

    const { toast: toastId } = identifiersData.ids;

    const takeDownAppleDistribution = async (id) => {
        try {
            await takeDownAppleDistributionAction({
                onCompleted: () => {
                    dispatch(openAlert(t("messages.takeDownMsgs.success"), statusTypesData.success));
                },
                variables: {
                    commandMode: "upload",
                    id,
                },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        } finally {
            toast.dismiss(`${startedDistributionTakeDownToastName}_${toastId}`);
        }
    };

    useEffect(
        () => {
            if (loading) {
                toast.info(() => t("messages.takeDownMsgs.started"), {
                    toastId: `${startedDistributionTakeDownToastName}_${toastId}`,
                });
            }
        },
        [loading], //eslint-disable-line
    );

    return { takeDownAppleDistribution };
};

export default useTakeDownAppleDistribution;
